export default __webpack_public_path__ + "static/media/trash-svgrepo-com-red.a44e91f8.svg";